import React from 'react';
import Responsive from 'react-responsive';

export const Mobile = props => <Responsive {...props} maxWidth={767} />;
export const ApplyMobile = props => <Responsive {...props} maxWidth={1023} />;
export const Default = props => <Responsive {...props} minWidth={768} />;
export const ApplyDefault = props => <Responsive {...props} minWidth={1024} />;

export default Default;
